import React from "react";
import "../styles/App.css";

export default function PageSplash() {
  return (
    <div className="page-splash" role="status" aria-live="polite">
      <div className="splash-dots" aria-hidden>
        <span className="dot d1" />
        <span className="dot d2" />
        <span className="dot d3" />
        <span className="dot d4" />
        <span className="dot d5" />
      </div>
    </div>
  );
}
